import {
  Injectable,
} from '@angular/core';
import {
  Actions,
  createEffect,
  ofType,
} from '@ngrx/effects';
import {
  select,
  Store,
} from '@ngrx/store';
import {
  AnalyticsSetUser,
  AnalyticsState,
  User as AnalyticsUser,
  Profile,
  selectAnalyticsUser,
} from '@refx/analytics-core';
import {
  SetLoginProfileTravelersInTravelerDetailsUI,
  TravelerDetailsUIState,
} from '@refx/shared-store';
import {
  filter,
  map,
  withLatestFrom,
} from 'rxjs/operators';

@Injectable()
export class AnalyticsUpdateUserEffect {
  public updateFromLogin$ = createEffect(() => this.actions$.pipe(
    ofType(
      SetLoginProfileTravelersInTravelerDetailsUI
    ),
    withLatestFrom(
      this.store.pipe(select(selectAnalyticsUser), filter((users): users is AnalyticsUser[] => !!users))
    ),
    map(([_action, users]) => {
      const updatedUsers: AnalyticsUser[] = users.map((user: AnalyticsUser) => {
        return {
          ...user,
          profile: user.profile.map((profile: Profile) => {
            return {
              ...profile,
              profileInfo: {
                ...profile.profileInfo,
                loginStatus: true
              }
            };
          })
        };
      });
      return AnalyticsSetUser({
        users: updatedUsers
      });
    })
  ));

  constructor(protected actions$: Actions, protected store: Store<TravelerDetailsUIState & AnalyticsState>) {}
}
